import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Snackbar from 'widgets/Snackbar';
import Button from 'widgets/Button';
import { closeNotice } from 'redux/actions/notice';
import colors from 'assets/styles/jsVariables/colors';
import './Notice.scss';

const styles = {
  buttonStyle: {
    '&:hover': {
      backgroundColor: 'initial'
    }
  },
  buttonLabelStyle: {
    color: colors.cyan
  },
  contentMessage: {
    display: 'inline-block',
    width: 'calc(100% - 70px)'
  },
  contentAction: {
    display: 'inline-block',
    position: 'absolute',
    top: 8,
    right: 10,
    alignItems: 'initial',
    marginLeft: 'initial',
    paddingLeft: 0,
    marginRight: 0
  }
};

export class Notice extends Component {
  handleRequestClose = () => {
    this.props.closeNotice();
  }

  action = (
    <Button
      cssStyles={{
        root: styles.buttonStyle,
        label: styles.buttonLabelStyle,
      }}
      size="small"
      onClick={this.handleRequestClose}
    >
      <FormattedMessage id="components.notice.buttonLabel" />
    </Button>
  );

  render() {
    const { notification: { open, message } } = this.props;
    return (
      <Snackbar
        open={open}
        message={message}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        action={this.action}
        className="Notice"
        cssStyles={{
          messageContentProps: styles.contentMessage,
          actionContentProps: styles.contentAction
        }}
        onClose={this.handleRequestClose}
        style={{ zIndex: 10000 }}
      />
    );
  }
}

Notice.propTypes = {
  closeNotice: PropTypes.func.isRequired,
  notification: PropTypes.object.isRequired,
};

function mapStateToProps({ notification }) {
  return { notification };
}

export default connect(mapStateToProps, { closeNotice })(Notice);



// WEBPACK FOOTER //
// ./src/components/Notice/Notice.jsx